"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'googleDrive.directoryPicker.selectDirectory': 'Seleziona directory',
    'googleDrive.directoryPicker.selected': 'Selezionata',
};
